// import './WebDisplayMiddle.css';
import React, { useEffect, useMemo, useState } from 'react';
import { desktopAttr, selectedToStyle, styles, attributes, colorStyles } from './PropsAvatar';
import { useWindowDimensions } from '../../helpers/screenDimensions';
import '../../styles/AvatarCreation.css';
import { EditDisplayAvatar } from './EditAvatarDisplay';

export const WebDisplayMiddle = ({ setHideOnDisplay, counter, setCounter, setHidden, hidden, setCustomize, props: [avatarStyleProps, setAvatarStyleProps, avatarColorProps, setAvatarColorProps] }) => {
    const { width } = useWindowDimensions();
    const [selected, setSelected] = useState(false);
    const [styleIndex, setStyleIndex] = useState(null);
    const [toPickFrom, setToPickFrom] = useState([]);
    const [hideArrows, setHideArrows] = useState(true);
    const [colorStyleID, setColorStyleID] = useState(-1);
    const [listOfColors, setListOfColors] = useState(null);
    const [hideOptions, setHideOptions] = useState(false);

    useEffect(() => {
        if (width > 992) {
            setHideOnDisplay(true);
        }
    }, []);

    useMemo(() => {
        if (styleIndex) {
            avatarStyleProps[selectedToStyle[styleIndex]] = toPickFrom[counter];
        }
    });

    function handleSelect(e) {
        setSelected(true);
        setHideOptions(false);
        const index = e.target.id || e.target.parentElement.id;
        setHideOnDisplay(true);
        if (hideArrows) {
            setHideArrows(!hideArrows);
        }
        if (counter > 0) {
            setCounter(0);
        }
        setColorStyleID(attributes.options[index].colorOptions);
        setStyleIndex(index);
        const styleList = styles[index].filter(e => e !== avatarStyleProps[selectedToStyle[index]]);
        styleList.unshift(avatarStyleProps[selectedToStyle[index]]);
        setToPickFrom(styleList);
        setListOfColors(colorStyles[attributes.options[index].colorOptions]);
    }

    function handleSave(styleNum) {
        const key = selectedToStyle[styleIndex];
        const newProps = { ...avatarStyleProps };
        newProps[key] = toPickFrom[styleNum];
        setAvatarStyleProps(newProps);
        handleClose();
    }

    function handleClose(e) {
        setHidden(!hidden);
        setHideArrows(!hideArrows);
        setCounter(0);
        setSelected(false);
        setHideOnDisplay(false);
        setCustomize(false);
    }

    return (
        <>
            <div
                className='outer-most flex items-center justify-center w-90 h-100 relative'>
                <div className='spacer w-12'/>
                <div
                    className='left-column flex-grow-1 gap-2 flex flex-col w-100 h-100 lg:gap-1.5'>
                    {desktopAttr.left.map((elem, index) => {
                        return (
                            <button
                                className='button w-60 h-12 flex bg-blueShade1 rounded-xl m-auto items-align justify-center pl-4' key={index}
                                id={elem.id}
                                onClick={(e) => handleSelect(e)}
                            >
                                <img src={elem.icon} id={elem.id} className='w-7 m-2' />
                                <p
                                    id={elem.id}
                                    className='text-4 flex-grow-1 text-center text-white capitalize m-2.5 font-bold'
                                >
                                    {elem.name}
                                </p>
                            </button>
                        );
                    })}
                </div>
                <div className='spacer w-12' />
                <EditDisplayAvatar
                    props={[avatarStyleProps, setAvatarStyleProps, avatarColorProps, setAvatarColorProps]}
                    setCounter={setCounter}
                    toPickFrom={toPickFrom}
                    hideArrows={hideArrows}
                    selected={selected}
                    counter={counter}
                    colorStyleID={colorStyleID}
                    listOfColors={listOfColors}
                />
                <div className='spacer w-12' />
                <div
                    className='right-column flex-grow-1 gap-2 flex flex-col w-100 capitalize h-100'>
                    {desktopAttr.right.map((elem, index) => {
                        return (
                            <button
                                className='button w-60 h-12 flex bg-blueShade1 rounded-xl m-auto items-align justify-center pl-4' key={index}
                                id={elem.id}
                                onClick={(e) => handleSelect(e)}
                            >
                                <img src={elem.icon} className='w-7 m-2' />
                                <p
                                    className='text-4 flex-grow-1 text-center text-white capitalize m-2.5 font-bold'
                                >
                                    {elem.name}
                                </p>
                            </button>
                        );
                    })}
                </div>
                <div className='spacer w-12'/>
            </div>
            {selected & !hideOptions
                ? <div className='end-buttons flex gap-12'>
                    <button
                        className='avatarButton cursor-pointer bg-gradient-to-br from-blueShade1 to-blueShade2 text-center justify-around no-underline whitespace-nowrap outline-none touch-manipulation text-white transition duration-200 select-none font-medium text-base px-4 py-2.5 rounded-xl'
                        onClick={(e) => {
                            handleSave(counter);
                        }}>
                        Save
                    </button>
                    <button
                        className='avatarButton cursor-pointer bg-gradient-to-br from-blueShade1 to-blueShade2 text-center justify-around no-underline whitespace-nowrap outline-none touch-manipulation text-white transition duration-200 select-none font-medium text-base px-4 py-2.5 rounded-xl'
                        onClick={(e) => {
                            handleClose(e);
                        }}>
                        Back
                    </button>
                </div>
                : null
            }
        </>
    );
};
